document.addEventListener('DOMContentLoaded', function () {
  var animation_wrap = document.querySelector('.perfect-match-reviews__columns');
  var after_btn_text = document.querySelector('.after_btn_text');
  var reviews_text_caption = document.querySelector('.perfect-match-reviews__text--caption');
  if (animation_wrap.classList.contains('perfect-match-reviews__columns--animation')) {
    const leftElement = document.querySelector('.col_left');
    const rightElement = document.querySelector('.col_right');

    function animateElement(element) {
      element.style.transition = 'transform 30s linear';
      element.style.transform = 'translateY(-50%)';

      element.addEventListener(
        'transitionend',
        () => {
          element.style.transition = 'none';
          element.style.transform = 'translateY(0)';

          // Запускаємо анімацію знову
          requestAnimationFrame(() => {
            setTimeout(() => {
              element.style.transition = 'transform 30s linear';
              element.style.transform = 'translateY(-50%)';
            }, 50);
          });
        },
        { once: true }
      );
    }

    function startAnimation(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateElement(leftElement);
          setTimeout(() => {
            animateElement(rightElement);
          }, 1550);
        }
      });
    }

    const observer = new IntersectionObserver(startAnimation, {
      root: null,
      threshold: 0.1,
    });

    observer.observe(animation_wrap);
  }
  if (after_btn_text) {
    after_btn_text.parentElement.style.marginTop = '10px';
  }
});
